export { default } from 'nosleep.js';